"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgGearFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M6.37 18.644a2 2 0 01-2.687-.742l-1.025-1.748a2 2 0 01.714-2.737l.023-.014.677-.384a7.754 7.754 0 01-.017-2.036l-.67-.384a2 2 0 01-.74-2.73l.009-.014 1.022-1.748a2 2 0 012.713-.73l.647.366A7.32 7.32 0 019.03 4.558l-.005-.535A2 2 0 0111.002 2h2.007a2 2 0 012 2v.572a8.12 8.12 0 011.956 1.178l.622-.36a2 2 0 012.722.71l1.037 1.747a2 2 0 01-.698 2.741l-.025.015-.682.39c.083.68.083 1.355.002 2.026l.67.381a2.002 2.002 0 01.749 2.728l-.02.033-1.04 1.748a2 2 0 01-2.697.722l-.651-.365c-.646.513-1.293.901-1.945 1.161v.578a2 2 0 01-2 2h-.003l-2.012-.003a2 2 0 01-1.997-1.998c0-.193 0-.394.003-.601a7.519 7.519 0 01-1.957-1.128l-.672.369H6.37zM12.01 8c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z' }))); };
exports.default = SvgGearFilled;
//# sourceMappingURL=GearFilled.js.map